export function getDataLabProjectUrl(projectId: string): string {
  return `/data-lab/${projectId.toUpperCase()}`;
}
